import { Notification } from "@novu/react";

export interface HSPNotification extends Notification {
  data: {
    keys: string;
    values: string;
  };
}

export function getPathFromNotification(n: HSPNotification): string {
  const keys = n.data.keys.split("||");
  const values = n.data.values.split("||");

  const data: Record<string, string> = keys.reduce(
    (acc, key, index) => {
      acc[key] = values[index];
      return acc;
    },
    {} as Record<string, string>,
  );

  data.id = n.id;
  const type = data.type;
  const process = data.process;
  const requestId = data.requestId;
  const escalationId = data.escalationId;
  const milestoneId = data.milestone;

  const isPublic = data.isPublic;

  switch (type) {
    case "process-start-reminder":
      return `/process/${process}/milestones`;
    case "task-due-tomorrow":
    case "overdue-status-change":
    case "task-status-change":
    case "payroll-payslip-processing-completion":
    case "flag-task":
      return `/process/${process}/milestones?milestoneId=${milestoneId}`;
    case "new-request":
      return `/requests/${requestId}/conversation`;
    case "request-update":
      return `/requests/${requestId}/conversation`;
    case "escalation-raised":
      return `/escalations/${escalationId}/conversation`;
    case "ad-hoc-status-update":
      return `/requests/${requestId}/conversation`;
    case "escalation-updates":
      return `/escalations/${escalationId}/conversation`;

    case "new-message":
      return isPublic === "true"
        ? `/process/${process}/conversations/public`
        : `/process/${process}/conversations/internal`;
    case "comment-on-task":
      return isPublic === "true"
        ? `/process/${process}/conversations/public`
        : `/process/${process}/conversations/internal`;
    case "bulk-import-complete":
    case "bulk-import-failed":
      return "/settings/import-payslip-events";
    default:
      return "/";
  }
}
